<template>
  <div class="language-switcher">
    <button
      v-for="lang in availableLangs"
      :key="lang.code"
      @click="switchLanguage(lang.code)"
      :class="{ active: currentLang === lang.code }"
    >
      {{ lang.flag }} {{ lang.name }}
    </button>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

export default {
  setup() {
    const { locale } = useI18n()
    const availableLangs = [
      { code: 'zh-CN', name: '简', flag: '🇨🇳' },
      { code: 'zh-HK', name: '繁', flag: '🇭🇰' },
      { code: 'en-US', name: 'EN', flag: '🇺🇸' },
      { code: 'ja-JP', name: '日', flag: '🇯🇵' }
    ]

    const selectedLang = ref(locale.value)

    const switchLanguage = (langCode) => {
      locale.value = langCode
      localStorage.setItem('userLanguage', langCode)
    }

    return {
      currentLang: locale,
      availableLangs,
      selectedLang,
      switchLanguage
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

button {
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.2);
  color: #2c3e50;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

button:hover {
  background: rgba(0,123,255,0.1);
  border-color: #007bff;
}

button.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

@media (max-width: 768px) {
  .language-switcher {
    flex-direction: column;
    align-items: stretch;
  }
  
  button {
    justify-content: center;
  }
}
</style> 